export default __webpack_public_path__ + "static/media/Digital-Patreon-Logo_White.cdb5c0a9.png";